import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/axios'
import './plugins/vueCookie'
import './plugins/veelidate'
import './permission' // permission control
import { removeToken } from '@/utils/auth'

Vue.config.productionTip = false

// Limpieza forzada de sesión SOLO cuando el build se generó con "npm run deploy force"
if (process.env.VUE_APP_FORCE_CLEAN_SESSION === '1') {
    removeToken()
}

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
}).$mount('#app')
